import { asyncRoutes, constantRoutes } from '@/router'
import { menuSelectTree } from '@/api/auth'

const state = {
  routes: [],
  // addRoutes: []
  menus: [],
  auths: [],
  buttons: [],
}


/**
 * Filter asynchronous routing tables by recursion
 * @param asyncRoutes asyncRoutes
 * @param urlsMap 一个url=>name Map
 */
function filterAsyncRoutes(asyncRoutes, urlsMap) {
  // todo 过滤router
  let _router = copyAsyncRoutes(asyncRoutes)
  let route_url = [];
  function recursionRoute(routes){
    for(let i = 0; i < routes.length; i++){
      route_url.push(routes[i].path);

      if(routes[i].children && routes[i].children.length>0){
        // 有子节点递归子节点
        recursionRoute(routes[i].children);
        // 如果出递归后children长度为0 splice当前节点
        if(routes[i].children.length == 0){
          routes.splice(i,1);
          i --;
        }
      }else{
        // 如果没有子节点，则当前节点为根节点
        let needItem = false;
        // 去已授权url中查看是否保留当前路由
        for (let [key, value] of urlsMap) {
          let urlString = route_url.join("/");

          if(urlString.includes(":")){
            // 动态地址路由,获取动态地址前的URL
            let _url = urlString.split("/:")[0];
            let r = RegExp(`^${_url}(/[0-9,a-z]+)?$`);
            if(r.test(key)){
              needItem = true;
            }
          }else{
            if(urlString.indexOf(key) > -1){
              needItem = true;
            }
          }

        }
        // 保留通配符的/404跳转
        if(!needItem && routes[i].path!= "*"){
          routes.splice(i,1);
          i --;
        }
      }
      route_url.pop();
    }
  }
  // 递归动态路由副本
  recursionRoute(_router);
  return _router;
}

// 复制一份路由数据
function copyAsyncRoutes(routes) {
  const res = []
  routes.forEach(route => {
    const tmp = { ...route }
      if (tmp.children) {
        tmp.children = copyAsyncRoutes(tmp.children)
      }
      res.push(tmp)
  })
  return res
}

/**
 * 分离权限树上 权限项和按钮项
 * @param  {object} treeData
 * 服务器请求到的数型权
 * @return {
    menus,auths,buttons
 */
function classifyPermission(treeData){
  let menus = [];
  let auths = [];
  let buttons = [];
  let urls = new Map();

  /**
   * 设置自定义页面权限的url
   * menuUrl = /iframe/menuId
   * 新的url = /自定页的动状路由地址/权限的menuId
   * @param {object} node 一个权限树上的节点
   */
  function setIframeUrl(node){
    if(node.viewUrl) node.menuUrl += `/${node.menuId}`;
  }

  function traverseNodes(nodes){
    for(let i = 0; i < nodes.length; i ++){
      let _node = nodes[i];
      if(_node.menuType != "menu"){
        if(_node.menuType == "auth"){
          auths = auths.concat(nodes.splice(i,1));
        }
        if(_node.menuType == "button"){
          buttons = buttons.concat(nodes.splice(i,1));
        }
        i --;
      }else{ // 是菜单
        if((_node.nodes instanceof Array && _node.nodes.length == 0)
          ||(_node.nodes instanceof Array && !_node.nodes.some(item=>item.menuType=="menu"))){
          urls.set(_node.menuUrl,_node.menuName)
        }
        setIframeUrl(_node);
      }
      if(_node.nodes instanceof Array && _node.nodes.length > 0){
        traverseNodes(_node.nodes);
      }
    }

  }
  traverseNodes(treeData);
  for(let button of buttons){
    if(button.menuUrl) urls.set(button.menuUrl,button.menuName);
  }
  menus = treeData;
  return {menus,auths,buttons,urls};
}



const getters = {
  // 获取自定义菜单的iframe地址
  getIframeMap: (state) => url => {
    function recursion(arr) {
      for (let item of arr) {
        if (typeof item.viewUrl === "string" && item.viewUrl.includes(url)) {
          console.log(`${item.menuUrl}/${item.menuId}`)
          return `${item.menuUrl}`;
        }
        let temp = recursion(item.nodes);
        if (temp) {
          return temp;
        }
      }
      return "";
    }
    return recursion(state.menus);
	},
}

const mutations = {
  SET_ROUTES: (state, routes) => {
    // state.addRoutes = routes
    state.routes = constantRoutes.concat(routes)
  },
  SET_MENU: (state, menus) => {
    state.menus = menus;
  },
  SET_AUTHS: (state, auths) => {
    state.auths = auths;
  },
  SET_BUTTONS: (state, buttons) => {
    state.buttons = buttons;
  },
}

const actions = {
  generateRoutes ({ commit, state, dispatch, rootState }, roles) {
    return new Promise(resolve => {
      menuSelectTree({}).then(res=>{
        if(res.errcode != 0) return false;
        let {menus,auths,buttons,urls} = classifyPermission(res.data)
        commit("SET_MENU", menus);
        commit("SET_AUTHS", auths);
        commit("SET_BUTTONS", buttons);

        let _asyncRoutes = filterAsyncRoutes(asyncRoutes,urls);
        commit("SET_ROUTES", _asyncRoutes);
        resolve(_asyncRoutes)
      }).catch(error=> {
        // reject(error)
      })
    })
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
